import React, { memo } from 'react';
import styles from './range.module.scss';

export const Range = memo(({num,totalNum}) => {

  const currentPercentage = `${num*100/totalNum}%`;

  return (
    <div className={styles.wrap}>
      <div className={styles.titleArea}>
        <span className={styles.title}>start</span>
        <span className={`${styles.title}`}>{num}/{totalNum}問</span>
        <span className={styles.title}>Finish</span>
      </div>
      <div className={styles.bar_wrap}>
        <div
          className={styles.bar}
          style={{ width: currentPercentage }}
        ></div>
        <div className={styles.bottom_bar}></div>
      </div>
    </div>
  );
});
